import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { TopPage } from "@/components/elements/TopPage";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { TUserSettingEmailForm } from "@/features/user-setting/types/UserSettingEmailForm";
import { AppRoutes } from "@/routes/config";
import { Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { divider } from "@/theme/colors";
import { IconPlaylistAddCheck } from "@/assets/icons";

type TChangeEmailFormProps = {
  methods: UseFormReturn<TUserSettingEmailForm>;
  currentEmail: string;
  handleConfirm: (data: TUserSettingEmailForm) => Promise<void>;
  schema: yup.ObjectSchema<TUserSettingEmailForm>;
};

export const ChangeEmailForm: FC<TChangeEmailFormProps> = ({ methods, currentEmail, handleConfirm, schema }) => {
  const navigate = useNavigate();
  const { control } = methods;

  const onSubmit = async (data: TUserSettingEmailForm) => {
    await handleConfirm(data);
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} schema={schema}>
      <Stack
        gap={1}
        sx={{
          minHeight: "calc(100vh - 194px)",
        }}
      >
        <TopPage title="メールアドレス変更" enablePageBack={false} />
        <InnerBox padding={3} mt={3} showDivider={false} borderColor={divider.high}>
          <Stack gap={5}>
            <Stack gap={2}>
              <Stack gap={3}>
                <Stack gap={1.5}>
                  <Typography variant="cap12">現在のメールアドレス</Typography>
                  <Typography variant="body14">{currentEmail}</Typography>
                </Stack>
                <Stack gap={1.5}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormField control={control} name="email">
                        <Input />
                      </FormField>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </InnerBox>
      </Stack>
      <FooterContainer>
        <Stack gap={1} direction="row" justifyContent="space-between" alignItems="center">
          <Button variant="ghost" onClick={() => navigate(AppRoutes.userSettingDetail)}>
            戻る
          </Button>
          <Stack direction="row" gap={3}>
            <Button type="submit" size="md" variant="primary" startIcon={<IconPlaylistAddCheck fontSize={20} />}>
              確認
            </Button>
          </Stack>
        </Stack>
      </FooterContainer>
    </Form>
  );
};
